/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: LogProfilesActions.tsx
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Action buttons component for Log Profiles DataGrid rows.
────────────────────────────────────────────────────────────────*/

import { Edit, Copy, Trash2 } from 'lucide-react';
import { useI18n } from '../../../hooks/useI18n';
import SimpleTooltip from '../../../components/ui/SimpleTooltip';
import { LogProfile } from '../types';

interface LogProfilesActionsProps {
  item: LogProfile;
  onEdit: (item: LogProfile) => void;
  onDuplicate: (item: LogProfile) => void;
  onDelete: (item: LogProfile) => void;
}

export function LogProfilesActions({
  item,
  onEdit,
  onDuplicate,
  onDelete,
}: LogProfilesActionsProps) {
  const { t } = useI18n();

  return (
    <div className="flex items-center gap-1.5">
      <SimpleTooltip content={t('logProfiles.actions.edit')} position="top">
        <button
          type="button"
          onClick={() => onEdit(item)}
          aria-label={t('logProfiles.actions.edit')}
          className="p-2 text-blue-600 hover:bg-blue-50 dark:text-blue-400 dark:hover:bg-blue-900/20"
        >
          <Edit className="h-4 w-4" />
        </button>
      </SimpleTooltip>
      <SimpleTooltip content={t('logProfiles.actions.duplicate')} position="top">
        <button
          type="button"
          onClick={() => onDuplicate(item)}
          aria-label={t('logProfiles.actions.duplicate')}
          className="p-2 text-green-600 hover:bg-green-50 dark:text-green-400 dark:hover:bg-green-900/20"
        >
          <Copy className="h-4 w-4" />
        </button>
      </SimpleTooltip>
      <SimpleTooltip content={t('logProfiles.actions.delete')} position="top">
        <button
          type="button"
          onClick={() => onDelete(item)}
          aria-label={t('logProfiles.actions.delete')}
          className="p-2 text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/20"
        >
          <Trash2 className="h-4 w-4" />
        </button>
      </SimpleTooltip>
    </div>
  );
}

